import styled from '@emotion/styled';
import { withProps } from 'recompose';

export const ManageTags = withProps({ type: 'button' })(styled.button`
  display: flex;
  align-items: center;
  border-radius: ${props => props.theme.borderRadii.large};
  background-color: rgba(0, 0, 0, 0.15);
  padding: 8px;
`);

export const BackToTagsButton = withProps({ type: 'button' })(styled.button`
  display: flex;
  align-items: center;
  margin-right: auto;
  padding: 0 0 8px 0;
`);

export const EditTagInput = styled.input`
  font-size: 16px;
  border: none;
  margin: 1em 0;
  height: 42px;
  padding: 8px 0px 8px 5px;
  border-radius: 10px;
  color: #64748B;
  flex-direction: column;
  color: #0E0E0E;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
  letter-spacing: 0.16px;
  &:focus, &:active {
    border: 1px solid #9B59B6;
    background: #F5EEF8;
  }
  `;
